export const sortOptions = [
  {
    id: 1,
    value: "minsqft",
    label: "Size: Smallest to Largest",
    order: "asc",
    arg: "sqft",
  },
  {
    id: 2,
    value: "maxsqft",
    label: "Size: Largest to Smallest",
    order: "desc",
    arg: "sqft",
  },
  {
    id: 3,
    value: "minrent",
    label: "Price: Low to High",
    order: "asc",
    arg: "min_rent",
  },
  {
    id: 4,
    value: "maxrent",
    label: "Price: High to Low",
    order: "desc",
    arg: "min_rent",
  },
];

export const transformData = (req) => {
  const options = {
    bedroom: {
      options: [{ id: "any", value: "", label: "Bedroom" }],
    },
    price: {
      options: [{ id: "any", value: "", label: "Max Price" }],
    },
    sqFt: {
      options: [{ id: "any", value: "", label: "Square Feet" }],
    },
    sort: {
      options: [{ id: "any", value: "", label: "Sort By" }],
    },
    minDate: req.minDate,
  };

  // Process bedrooms
  const regularBedrooms = Object.entries(req.bedrooms)
    .filter(([key]) => key !== "-1")
    .sort(([a], [b]) => Number(a) - Number(b));

  // Add regular bedrooms
  regularBedrooms.forEach(([key, value], index) => {
    const formattedValue = key === "0" ? "studio" : `${key}-bed`;
    options.bedroom.options.push({
      id: index,
      value: formattedValue,
      label: value,
    });
  });

  // Add -1 bedroom option last if it exists
  if (req.bedrooms["-1"]) {
    options.bedroom.options.push({
      id: regularBedrooms.length,
      value: "-1-bed",
      label: req.bedrooms["-1"],
    });
  }

  // Process price range
  req.priceRange.forEach((price, index) => {
    const formattedPrice = `$${price.toLocaleString()}`;
    options.price.options.push({
      id: index,
      value: `${price}`,
      label: formattedPrice,
    });
  });

  // Process square feet (assumed floors correspond to square feet range)
  req.sqFt.forEach((sqFt, index) => {
    options.sqFt.options.push({
      id: index,
      value: `${sqFt}`,
      label: `${sqFt} sq. ft.`,
    });
  });

  // Default sort option
  options.sort.options.push(...sortOptions);

  return options;
};

export const getSortArg = (sort) => {
  const sortOption = sortOptions.find((option) => option.value === sort);
  return sortOption?.arg || "";
};

export const getSortOrder = (sort) => {
  const sortOption = sortOptions.find((option) => option.value === sort);
  return sortOption?.order || "";
};

export const getSortLabel = (sort) => {
  const sortOption = sortOptions.find((option) => option.value === sort);
  return sortOption?.label || "";
};

export const getSortValue = (sort, direction) => {
  const sortOption = sortOptions.find(
    (option) => option.arg === sort && option.order === direction
  );
  return sortOption?.value || "";
};

export const getSortValueRaw = (sort) => {
  const sortOption = sortOptions.find((option) => option.value === sort);
  return sortOption?.arg || "";
};
